export const GAME_WIDTH = 540;
export const GAME_HEIGHT = 960;

// Central shaft bounds
export const SHAFT_LEFT = 50;
export const SHAFT_RIGHT = 490;
export const SHAFT_WIDTH = SHAFT_RIGHT - SHAFT_LEFT;
export const SHAFT_CENTER_X = (SHAFT_LEFT + SHAFT_RIGHT) / 2;

// Vertical landmarks
export const HUD_TOP_Y = 35;
export const LASER_Y = 110;
export const LASER_HEIGHT = 14;
export const LASER_BOTTOM_Y = LASER_Y + LASER_HEIGHT;
export const FLOOR_Y = 820;

export const CUBE_SIZE = 40;
export const PLAYER_START_Y = 260;

export const BARRIER_HEIGHT = 22;

export const SCENES = {
    start: "start",
    game: "game",
    gameOver: "gameover",
} as const;

export const HIGH_SCORE_KEY = "colourfalls_highscore";
